import type { RichTextSection } from "@/types/content";

interface Props {
  section: RichTextSection;
}

const proseOverrides = `
  max-w-[720px] mx-auto
  prose prose-slate
  prose-headings:text-slate-800 prose-headings:font-bold prose-headings:scroll-mt-24
  prose-h1:text-3xl prose-h1:md:text-4xl prose-h1:mt-10 prose-h1:mb-6 prose-h1:pb-4 prose-h1:border-b prose-h1:border-slate-100
  prose-h2:text-[1.4rem] prose-h2:md:text-[1.6rem] prose-h2:mt-12 prose-h2:mb-5 prose-h2:pb-3 prose-h2:border-b prose-h2:border-slate-100
  prose-h3:text-xl prose-h3:md:text-[1.35rem] prose-h3:mt-10 prose-h3:mb-4
  prose-h4:text-lg prose-h4:md:text-xl prose-h4:mt-8 prose-h4:mb-3
  prose-p:text-[15px] prose-p:md:text-base prose-p:text-slate-700 prose-p:leading-[1.8] prose-p:mb-5
  prose-a:text-primary prose-a:no-underline prose-a:font-medium hover:prose-a:underline
  prose-strong:text-slate-800 prose-strong:font-bold
  prose-ul:pl-5 prose-ul:mb-5 prose-ul:space-y-1.5
  prose-ol:pl-5 prose-ol:mb-5 prose-ol:space-y-1.5
  prose-li:text-[15px] prose-li:md:text-base prose-li:text-slate-700 prose-li:marker:text-slate-400
  prose-blockquote:border-l-[3px] prose-blockquote:border-primary/30 prose-blockquote:bg-slate-50/80 prose-blockquote:rounded-r-lg prose-blockquote:px-5 prose-blockquote:py-4 prose-blockquote:my-7 prose-blockquote:text-slate-600
  prose-hr:my-10 prose-hr:border-slate-100
  prose-img:rounded-xl prose-img:my-6 prose-img:shadow-none prose-img:border prose-img:border-slate-100
  prose-figure:my-6
  prose-figcaption:text-xs prose-figcaption:text-slate-400 prose-figcaption:mt-2 prose-figcaption:text-center
  prose-table:w-full prose-table:text-sm prose-table:my-6 prose-table:border-collapse
  prose-thead:border-b prose-thead:border-slate-200
  prose-th:text-left prose-th:px-3 prose-th:py-2.5 prose-th:bg-slate-50 prose-th:text-xs prose-th:font-semibold prose-th:text-slate-600
  prose-td:px-3 prose-td:py-2.5 prose-td:border-b prose-td:border-slate-100 prose-td:text-slate-700
  prose-tr:border-b prose-tr:border-slate-50
  [&_.comparison-table]:w-full [&_.comparison-table]:text-sm [&_.comparison-table]:my-6 [&_.comparison-table]:border-collapse
  [&_.comparison-table_th]:text-left [&_.comparison-table_th]:px-3 [&_.comparison-table_th]:py-2.5 [&_.comparison-table_th]:bg-slate-50 [&_.comparison-table_th]:text-xs [&_.comparison-table_th]:font-semibold [&_.comparison-table_th]:text-slate-600 [&_.comparison-table_th]:border-b [&_.comparison-table_th]:border-slate-200
  [&_.comparison-table_td]:px-3 [&_.comparison-table_td]:py-2.5 [&_.comparison-table_td]:border-b [&_.comparison-table_td]:border-slate-100 [&_.comparison-table_td]:text-slate-700
  [&_.comparison-table_tr]:border-b [&_.comparison-table_tr]:border-slate-50 [&_.comparison-table_tr:hover]:bg-slate-50/40
`;

export default function RichTextSectionBlock({ section }: Props) {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
      <div
        className={proseOverrides.trim().replace(/\s+/g, " ")}
        dangerouslySetInnerHTML={{ __html: section.content }}
      />
    </section>
  );
}